enum JobStatusType {
  OPEN,
  INPROGRESS,
  COMPLETED,
  READYTOINVOICE,
  INVOICED,
  CANCELLED
}

export enum JobStatusTypeLabel {
  OPEN = 'Open',
  INPROGRESS = 'In Progress',
  COMPLETED = 'Completed',
  READYTOINVOICE = 'Ready To Invoice',
  INVOICED = 'Invoiced',
  CANCELLED = 'Cancelled'
}

export default JobStatusType
